var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_5817)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_5817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_5817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 13.4368V22.218C32.9985 22.6551 32.8241 23.0738 32.5151 23.3829C32.206 23.6919 31.7873 23.8662 31.3502 23.8678H4.64977C4.2127 23.8662 3.79397 23.6919 3.48491 23.3829C3.17585 23.0738 3.00154 22.6551 3 22.218V13.4368H33Z",
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 13.4368H3V4.64977C3.00154 4.2127 3.17585 3.79397 3.48491 3.48491C3.79397 3.17585 4.2127 3.00154 4.64977 3H31.3502C31.7873 3.00154 32.206 3.17585 32.5151 3.48491C32.8241 3.79397 32.9985 4.2127 33 4.64977V13.4368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.4368L3.33346 3.65523C3.12285 3.93604 3 4.27535 3 4.64977V22.218C3 22.5924 3.12285 22.9376 3.33346 23.2126L18 13.4368Z",
    fill: "#11457E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_5817",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_5817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_5817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechRepublic);
export default __webpack_public_path__ + "static/media/CzechRepublic.f6c55cfaea63292ef975b83dc92747a1.svg";
export { ForwardRef as ReactComponent };